var sleepless = sleepless || {};
sleepless.accessibility = {
  setup: setup_accessibility,
  slickAccessible: slickAccessible,
  escapeClicker: escapeClicker,
  tabme: tab_me_plz,
  update_keep_focused: updateKeepFocused,
  cartA11yOn: cartA11yOn,
  cartA11yOff: cartA11yOff
};
$(document).ready(function () {
  $('.skipToContent').click(function () {
    $('.main-content-divider').focus();
  });
  $('.slick-dots').attr('aria-label', 'Carousel Controls');
  // $('.slick-track').attr('aria-label', 'Carousel');
  $('.slick-track').attr('role', 'region');
  $('.slick-track').attr('aria-live', 'polite');
  // $('.home-hero-carousel-slick').on('afterChange', function (event, slick, currentSlide) {
  //   $('.a11y-button-wrapper').attr('tabindex', '-1'); // $('.slick-slide.slick-active').focus();
  // });
  // $('.slick-dots button').wrap('<a href="" class="nostyle a11y-button-wrapper" prevent-click tabindex="-1"></a>');
  // $('.houseBar li').html('<a href="" class="nostyle a11y-button-wrapper" prevent-click tabindex="-1"></a>');
  $('.houseBar li').each(function (index) {
    $(this).focusin(function () {
      $(this).mouseover();
    });
    $(this).focusout(function () {
      $(this).mouseout();
    });
    $(this).find('a').attr('aria-label', 'Slide ' + (index + 1).toString());
  });
  $('.slick-dots li a').each(function (index) {
    var slideName = 'Slide ' + (index + 1).toString();
    $(this).attr('aria-label', slideName);
  });
  $("[tabindex-active-slide]").on("init", function (event, slick) {
    $(slick.$slider).find(".slick-slide.slick-active").attr("tabindex", "0");
    $(slick.$slider).find(".slick-active").attr("arrow-to-slides", "");
    addArrowToSlidesListener();
    resetSlideTabindex();
  });
  $("[tabindex-active-slide]").on("afterChange", function (event, slick, currentSlide) {
    $(slick.$slides[currentSlide]).siblings().attr("tabindex", "-1");
    $(slick.$slides[currentSlide]).attr("tabindex", "0");
    $(slick.$slides[currentSlide]).attr("arrow-to-slides", "");
    $(slick.$slides[currentSlide]).focus();
    addArrowToSlidesListener();
    resetSlideTabindex();
  });
  $("[tabindex]").on("focus", function (e) {
    window.lastTabbableElement = e.target;
  });
  $("[prevent-click]").click(function (e) {
    e.preventDefault();
  });
  $("[click-on-focus]").on("focus", function (e) {});
  $("[hover-on-focusin]").focusin(function (e) {
    $(e.target).trigger("mouseenter");
  });
  $("[enter-to-click]").on("keyup", function (e) {
    if (e.which == 13) {
      $(e.target).click();
    }
  });

	$( '.desktopImageWapper button' ).on( 'click', function( e ) {
    swapMe(e);
  } );

  function swapMe(event) {

    if ($('.ff-container').length == 0){
    

      if($(event.target).closest( 'button' ).hasClass('active')){
      }else{



      $(event.target).closest( 'button' ).siblings().removeClass('active');
      $(event.target).closest( 'button' ).addClass('active');

        if ($(event.target).closest( 'button' ).hasClass('flex-item--1')){
          $('#gif-img-wrapper-desktop2').hide();
          $('#gif-img-wrapper-desktop1').show();
        }else{
          $('#gif-img-wrapper-desktop1').hide();
          $('#gif-img-wrapper-desktop2').show();
        }
      }
    }
  }

  function addArrowToSlidesListener() {
    $("[arrow-to-slides]").on("keyup", function (e) {
      if ($(e.target).attr("arrow-to-slides") !== "") {
        // If value is passed to attribute, it will be assumed to be the slider class that it controls
        var sliderClass = $(e.target).attr("arrow-to-slides");
        var slider = $("." + sliderClass);

        if (e.which == "38") {// up arrow
        } else if (e.which == "40") {// down arrow
        } else if (e.which == "37") {
          $(slider).slick("slickPrev");
        } else if (e.which == "39") {
          $(slider).slick("slickNext");
        }
      } else {
        if (e.which == "38") {// up arrow
        } else if (e.which == "40") {// down arrow
        } else if (e.which == "37") {
          $(e.target).closest(".slick-slider").slick("slickPrev");
        } else if (e.which == "39") {
          $(e.target).closest(".slick-slider").slick("slickNext");
        }
      }
    });
  }

  addArrowToSlidesListener();
  $("[arrow-to-siblings]").on("keyup", function (e) {
    if (e.which == "38") {// up arrow
    } else if (e.which == "40") {// down arrow
    } else if (e.which == "37") {
      // left arrow
      $(e.target).prev().focus();
    } else if (e.which == "39") {
      //right arrow
      $(e.target).next().focus();
    }
  });
}); // --- functions ---

function setup_accessibility() {
  // Only remove outline when user is NOT tabbing (for accessibility)
  $(window).load(function () {});
}

function tab_me_plz() {
  $(window).load(function () {
    document.querySelector("body").addClass("user-is-tabbing");
  });
}

function slickAccessible($selector) {
  $selector.on("init", function () {
    resetSlideTabindex();
  });
  $selector.on("afterChange", function () {
    resetSlideTabindex();
  });
}

function resetSlideTabindex() {
  jQuery(".slick-slide, .slick-slide a").attr("tabindex", "-1");
  jQuery(".slick-slide, .slick-slide button").attr("tabindex", "-1");
  jQuery(".slick-slide.slick-active").attr("tabindex", "0");
  jQuery(".slick-active a").attr("tabindex", "0");
  jQuery(".slick-active button").attr("tabindex", "0");
}

function escapeClicker() {
  if (event.keyCode == 27) {
    var $toEscape = $("[escape-to-click]");
    $toEscape.click();
  }
}

function updateKeepFocused() {
  $("[trap-focus-while-visible]").each(function (index) {
    if ($(this).css("display") != "none") {
      if ($(this).attr('trap-family') != undefined) {
        var $tabbables = $('[trap-member="' + $(this).attr('trap-family') + '"]');
      } else {
        var $tabbables = $(this).find('[tabindex="0"], button, input, select, textarea, iframe').filter(':visible');
      }

      $tabbables.last().on("keydown", function (event) {
        if (event.which == 9) {
          $tabbables.first().focus();
          event.preventDefault();
        }

        if (event.shiftKey && event.keyCode == 9) {
          $tabbables[$tabbables.length - 2].focus();
          event.preventDefault();
        }
      });
      $tabbables.first().on("keydown", function (event) {
        if (event.shiftKey && event.keyCode == 9) {
          $tabbables.last().focus();
          event.preventDefault();
        }
      });
      $tabbables.first().focus();
    } else {
      var $tabbables = $(this).find('[tabindex="0"], button, input, select, textarea, iframe');
      $tabbables.last().off("keydown");
    }
  });
}

function cartA11yOn() {
  $(".cartContainer").find(".cart").find("select").unbind("change");
  $(".cartContainer").find(".cart").find("button.a11y-btn").click(function () {
    var $selectTarget = $(this).parent().find("select");
    var updateItem = $(this).parent().parent().parent().find(".remove").attr("data-num");
    var quan = $selectTarget.val();
    CartJS.updateItemById(updateItem, quan, {}, {
      success: function success(data, textStatus, jqXHR) {
        var element = CartJS.cart.item_count;
        var intervalID = setInterval(function () {
          if (element === CartJS.cart.item_count) {} else {
            populateCart();
            window.clearInterval(intervalID);
          }
        }, 100);
      }
    });
  });
}

function cartA11yOff() {
  $(".cartContainer").find(".cart").find("select").change(function () {
    var updateItem = $(this).parent().parent().parent().find(".remove").attr("data-num");
    var quan = $(this).val();
    CartJS.updateItemById(updateItem, quan, {}, {
      success: function success(data, textStatus, jqXHR) {
        var element = CartJS.cart.item_count;
        var intervalID = setInterval(function () {
          if (element === CartJS.cart.item_count) {} else {
            populateCart();
            window.clearInterval(intervalID);
          }
        }, 100);
      }
    });
  });
}

var addable = true;

$(document).ready(function() {
    $('[keyboardable]').on('keydown', function(e) {
        var code = e.which;
        if ((code === 13) || (code === 32)) {
          $(this).click();
        }
      });

      function setup_accessibility() {
        // Only remove outline when user is NOT tabbing (for accessibility)
        window.addEventListener('keydown', handle_first_tab);
      }
      
      // --- helpers ---
      function handle_first_tab(e) {
        if (e.keyCode === 9) { // the "I am a keyboard user" key
          document.body.classList.add('user-is-tabbing');
          window.removeEventListener('keydown', handle_first_tab);
          window.addEventListener('mousemove', removeTabStyle);
          sleepless.accessibility.cartA11yOn();
          //window.removeEventListener('keydown', handle_first_tab);
        }
      }
      
      function removeTabStyle(){
        document.body.classList.remove('user-is-tabbing');
        document.body.classList.remove('tabbingOn');
        window.removeEventListener('mousemove', removeTabStyle);
        window.addEventListener('keydown', handle_first_tab);
        sleepless.accessibility.cartA11yOff();
      }
      
      setup_accessibility();

      //
      // Homepage Hero Dots Aria-Label
      //
      $( '#shopify-section-homeCarousel-2020-v2 .dots-control li' ).each( function(){
        var buttonText = $( this ).find( 'button' ).text();
        var buttonIndex = parseInt(buttonText) - 1;
        var slideHeading = $( '.home-carousel-2020-v2 .slide[data-slick-index="'+buttonIndex+'"]' ).find( 'h1:first-child' ).text();
        $( this ).find( 'button' ).attr( 'aria-label', slideHeading.trim() );
      } );

      //
      // Homepage Hero Dots Aria-Current
      //
      $( '#shopify-section-homeCarousel-2020-v2 .dots-control li.slick-active button' ).attr( 'aria-current', 'true' );
      $('.home-carousel-2020-v2').on('afterChange', function(event, slick, currentSlide, nextSlide){
        $( '#shopify-section-homeCarousel-2020-v2 .dots-control li button' ).attr( 'aria-current', 'false' );
        $( '#shopify-section-homeCarousel-2020-v2 .dots-control li.slick-active button' ).attr( 'aria-current', 'true' );
      });

      //
      // Homepage Choose From Mobile Aria-Label
      //
      $( '#shopify-section-fathersDayBlade .dots-control li' ).each( function(){
        var buttonText = $( this ).find( 'button' ).text();
        var buttonIndex = parseInt(buttonText) - 1;
        var slideHeading = $( '#shopify-section-fathersDayBlade .slick-slide[data-slick-index="'+buttonIndex+'"]' ).find( '.featuredDCard__redText' ).text();        
        $( this ).find( 'button' ).attr( 'aria-label', slideHeading.trim() );
      } );

      //
      // Homepage Choose From Mobile Aria-Current
      //
      $( '#shopify-section-fathersDayBlade .dots-control li.slick-active button' ).attr( 'aria-current', 'true' );
      $( '#shopify-section-fathersDayBlade .slick-slide:not(.slick-current)').attr( 'aria-hidden', 'true' );
      $('.fathersDay__mobileSlider').on('afterChange', function(event, slick, currentSlide, nextSlide){
        $( currentSlide ).attr( 'aria-hidden', 'false' );
        $( '#shopify-section-fathersDayBlade .dots-control li button' ).attr( 'aria-current', 'false' );
        $( '#shopify-section-fathersDayBlade .dots-control li.slick-active button' ).attr( 'aria-current', 'true' );
      });

      //
      // Product Technical Specs Dots Aria-Label
      //
      setTimeout(function(){
        $( '.specs-slider-wrap .dots-control li' ).each( function(){
          var buttonText = $( this ).find( 'button' ).text();
          var buttonIndex = parseInt(buttonText) - 1;
          var slideHeading = $( '.specs-slider-wrap .slick-slide[data-slick-index="'+buttonIndex+'"] .slide-inner img' ).attr( 'alt' );
          $( this ).find( 'button' ).attr( 'aria-label', slideHeading );
        } );
        $( '.specs-slider-wrap .dots-control li.slick-active button' ).attr( 'aria-current', 'true' );
      }, 1000);

      //
      // Product Technical Specs Dots Aria-Current
      //
      $( '.specs-slider-wrap .slick-slide:not(.slick-current)').attr( 'aria-hidden', 'true' )
      $('.specs-slider-wrap .slides').on('afterChange', function(event, slick, currentSlide, nextSlide){
        $( currentSlide ).attr( 'aria-hidden', 'false' );
        $( '.specs-slider-wrap .dots-control li button' ).attr( 'aria-current', 'false' );
        $( '.specs-slider-wrap .dots-control li.slick-active button' ).attr( 'aria-current', 'true' );
      });
});